import { FunctionComponent } from 'react';
import { AddToCalendarButton } from '../AddToCalendarButton';
import { AccessCourseButton } from '../AccessCourseButton';
import Card from '../../../../../../Card';
import { PayInvoiceButton } from '../PayInvoiceButton';
import { DownloadInvoiceButton } from '../DownloadInvoiceButton';
import styles from './styles.module.scss';

type ConfirmationDetailsCardProps = {
    bookingId?: string;
};

export const ConfirmationDetailsCard: FunctionComponent<ConfirmationDetailsCardProps> = ({
    bookingId,
}) => {
    if (!bookingId) {
        return null;
    }

    return (
        <Card>
            <h3 className={styles.heading}>Check your inbox for a confirmation email</h3>
            <span className={styles.bookingReference}>Booking reference: {bookingId}</span>
            <div className={styles.buttons}>
                <AccessCourseButton bookingId={bookingId} />
                <PayInvoiceButton />
                <DownloadInvoiceButton />
                <AddToCalendarButton bookingId={bookingId} />
            </div>
        </Card>
    );
};
